<!--
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-08-15 15:13:30
 * @LastEditTime: 2019-10-18 18:29:18
 * @Version: 1.0
 * @Description: 罐区供给列表，状态：待发布、已发布、已成交。
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 -->

<template>
  <div class="content-container">
    <div class="supply-head">
      <div class="slider-list">
        <div :class="{ 'selected': state == '1'}" class="item" @click="toggleState('1')">待发布</div>
        <div :class="{ 'selected': state == '2'}" class="item" @click="toggleState('2')">已发布</div>
        <!-- <div :class="{ 'selected': state == '3'}" class="item" @click="toggleState('3')">已成交</div> -->
      </div>
      <!-- 查询表单  -->
      <div class="supply-head-form">
        <div class="fileds">
          <el-form ref="form" :model="queryParams" :inline="true" :rules="rule">
            <div class="supply-condition">
              <el-form-item label="租单名称:" prop="supplyName">
                <el-input v-model.trim="queryParams.supplyName" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="储存品类:" prop="storageType">
                <el-select v-model="queryParams.storageType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in storageType.tankType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="罐区容积:" prop="potStartArea">
                <div class="supply-area">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item prop="potStartArea">
                        <el-input v-model.number="queryParams.potStartArea" placeholder="请输入" @change="startChange" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <span>至</span>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item prop="potEndArea">
                        <el-input v-model.number="queryParams.potEndArea" placeholder="请输入" @change="endChange" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <el-form-item label="起租罐数:" prop="leasePotCount">
                <el-input v-model.trim="queryParams.leasePotCount" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="库房位置:" prop="storageLocation">
                <el-cascader
                  v-model="queryParams.storageLocation"
                  :options="area"
                  :filterable="true"
                  :props="{ expandTrigger: 'hover' ,
                            checkStrictly: true}"
                  style="width: 100%;"
                  @expand-change="expandChange"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="loadData"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>

    <!--存入表格数据-->
    <article class="operations">
      <el-button
        v-if="state == '1'"
        size="small"
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="publishsupply('2')"
      >
        <i class="el-icon-plus" />发布
      </el-button>
      <!-- <el-button
        v-if="state == '2'"
        size="small"
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="publishsupply('1')"
      >
        <i class="el-icon-plus" />取消发布
      </el-button> -->
      <el-button
        v-if="state == '1'"
        size="small "
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="batchDel"
      >
        <i class="el-icon-delete-solid" />批量删除
      </el-button>
    </article>

    <div :class="{'orderSupply-data' :state == '3','tankSupply-data' :state == '2','supply-data' :state != '2'}">
      <div class="supply-data-header">
        <ul>
          <li v-if="state == '1'">
            <el-checkbox v-model="allSelection" type="checkbox" @change="selection()" />
          </li>
          <li>租单名称</li>
          <li>储存品类</li>
          <li>库房位置</li>
          <li>罐区容积</li>
          <li>期望租金</li>
       
          <!-- <li v-if="!state">起租罐数</li> -->
          <li v-if="state == '2' ">预约企业</li>
          <li v-if="state == '2' ">邀请企业</li>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" v-loading="viewManager.loading" class="supply-data-body">
        <template v-if="!viewManager.loading && data.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(supply, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <li v-if="state == '1'">
                <el-checkbox v-model="supply.selection" type="checkbox" @change="change()" />
              </li>
              <el-tooltip class="item" effect="dark" :content="supply.supplyName" placement="top">
                <li>{{ supply.supplyName }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="supply.tankTypeLabel" placement="top">
                <li>{{ supply.tankTypeLabel }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="supply.storageLocationLabel" placement="top">
                <li>{{ supply.storageLocationLabel }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${supply.potArea}m³`" placement="top">
                <li>{{ supply.potArea }}m³</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${supply.expectPrice}元/罐/天`" placement="top">
                <li>{{ supply.expectPrice }}元/罐/天</li>
              </el-tooltip>

       

              <el-tooltip v-if="state == '2' " class="item" effect="dark" :content="JSON.stringify(supply.orderUser.length)" placement="top">
                <li><el-button type="text" @click="orderClick(supply)">{{ supply.orderUser.length }}</el-button></li>
              </el-tooltip>
              <el-tooltip v-if="state == '2' " class="item" effect="dark" :content="JSON.stringify(supply.inviteUser.length)" placement="top">
                <li><el-button type="text" @click="inviteClick(supply)">{{ supply.inviteUser.length }}</el-button></li>
              </el-tooltip>
              <li>
                <el-button v-if="state == '2'" type="text" @click="popRecommendList(supply)">需求推荐</el-button>
                <el-divider v-if="state == '2'" direction="vertical" />
                <el-button v-if="state == '2' && supply.orderUser.length < 1 && supply.inviteUser.length < 1" type="text" @click="publishGetSupply('1',supply)">取消发布</el-button>
                <!-- <el-divider v-if="state == '2'" direction="vertical" /> -->
                <el-button v-if="state == '1'" type="text" @click="edit(supply)">编辑</el-button>
                <el-divider v-if="state == '1'" direction="vertical" />
                <el-button v-if="state == '1'" type="text" @click="publishGetSupply('2',supply)">立即发布</el-button>
                <!-- <el-divider v-if="state == '1'" direction="vertical" /> -->
                <el-button v-if="state == '1'" type="text" style="color: #be2316 !important;" @click="del(supply.id)">删除</el-button>
                <el-divider v-if="state == '1'" direction="vertical" />
                <el-button plain size="small" style="color: #be2316 !important;" @click="supplyInfo(supply)">
                  详情
                  <i :class="{'expand': !supply.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <tankSupplyInfo v-if="!supply.hidden" :supply="supply" />
          </div>
        </template>
      </div>
      <div class="supply-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="invitationManager.visible"
      title="编辑"
      width="80%"
      @click="invitationManager.close"
    >
      <el-form
        ref="tankFarmSupply"
        :rules="tankFarmSupplyRules"
        :model="tankFarmSupply"
        :label-position="'right'"
        label-width="120px"
        style="padding-left: 0rem;padding-right: 2rem;"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="租单名称" prop="supplyName">
              <el-input v-model="tankFarmSupply.supplyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="储罐形状" prop="storageTankShape">
              <el-select v-model="tankFarmSupply.storageTankShape" placeholder="请选择">
                <el-option v-for="city in storageType.storageTankShape" :key="city.label" :label="city.label" :value="city.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起租日期" prop="leaseTime">
              <el-date-picker v-model="tankFarmSupply.leaseTime" :editable="false" type="date" :picker-options="pickerOptions" placeholder="选择日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="储存品类" prop="storageType">
              <el-checkbox-group v-model="tankFarmSupply.storageType">
                <el-checkbox v-for="city in storageType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="货物名称" prop="cargoName">
              <el-input v-model="tankFarmSupply.cargoName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储罐规格" prop="storageTankStandard">
              <el-input v-model="tankFarmSupply.storageTankStandard">
                <template slot="append">m³</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="储罐高度" prop="storageTankHeight">
              <el-input v-model="tankFarmSupply.storageTankHeight">
                <template slot="append">米</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储罐直径" prop="storageTankDiameter">
              <el-input v-model="tankFarmSupply.storageTankDiameter">
                <template slot="append">米</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="储罐型号" prop="storageTankType">
              <el-select v-model="tankFarmSupply.storageTankType" placeholder="请选择">
                <el-option v-for="city in storageType.storageTankType" :key="city.label" :label="city.label" :value="city.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可租罐数" prop="tenantablePotCount">
              <el-input v-model="tankFarmSupply.tenantablePotCount">
                <template slot="append">个</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="起租罐数" prop="leasePotCount">
              <el-input v-model="tankFarmSupply.leasePotCount">
                <template slot="append">个</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="租金" prop="expectPrice">
              <el-input v-model="tankFarmSupply.expectPrice">
                <template slot="append">元/罐/天</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="起租年限" prop="leaseTerm">
              <el-select v-model="tankFarmSupply.leaseTerm" placeholder="请选择">
                <el-option v-for="city in storageType.leaseTerm" :key="city.label" :label="city.label" :value="city.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="消防资质" prop="fireQualification">
              <el-select v-model="tankFarmSupply.fireQualification" placeholder="请选择">
                <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="库房位置" prop="storageLocation">
              <el-cascader
                v-model="tankFarmSupply.storageLocation"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover' ,
                          checkStrictly: true}"
                style="width: 100%;"
                class="storageLocation"
                @expand-change="expandChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细位置" class="detailedLocation" prop="detailedLocation">
              <el-autocomplete
                v-model="tankFarmSupply.detailedLocation"
                popper-class="my-autocomplete"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                style="width: 100%;"
                @select="handleSelect"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="罐区面积" prop="potArea">
              <el-input v-model="tankFarmSupply.potArea">
                <template slot="append">㎡</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="罐区耐火等级" prop="fireResistanceRating">
              <el-select v-model="tankFarmSupply.fireResistanceRating" placeholder="请选择罐区耐火等级">
                <el-option v-for="city in storageType.fireResistanceRating" :key="city.label" :label="city.label" :value="city.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="24">
            <el-form-item label="消防信息" prop="fireInformation">
              <el-input v-model="tankFarmSupply.fireInformation" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="库房照片" prop="storageUrl">
              <g-upload :max-size="1" :limit="6" is-edit :method-name="tankSupplyFile" :multiple="true" :img-list.sync="tankFarmSupply.storageUrl" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="tankFarmSupply.companyName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="联系人" prop="linkMan">
              <el-input v-model="tankFarmSupply.linkMan" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="telephone">
              <el-input v-model="tankFarmSupply.telephone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="罐区简介" prop="remarks">
              <el-input v-model="tankFarmSupply.remarks" type="textarea" :rows="6" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="">
              <span style="color: #be2316;">注：</span>
              <span>*均为必填项</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button type="danger" plain size="small" @click="tankFarmSupplyEdit('tankFarmSupply')">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <demandSuggest warehousing-type="2" :invitation-form="demandSuggestData" :invitation-manager="recommendManager.visible" @close="recommendManager.close" />
    <warehouseCompany warehousing-type="2" :ware-ord-inv-type="companyManager.type" :title-name="companyManager.title" warehouse-type="supply" :company-form="companyManager.data" :company-manager="companyManager.visible" @close="companyManager.close" />
  </div>
</template>

<script>
import AMap from 'AMap' // 引入高德地图
import tankSupplyInfo from './components/tankSupplyInfo'
import demandSuggest from '../components/demandSuggest'
import warehouseCompany from '../components/warehouseCompany'
import { findPageSupply, getArea, supplyRemove, delBatch, supplyEdit, getDict, issueBatch } from '@/api/personal/store/tank-supply-list/tankSupply'
import { tableClass } from '@/api/personal/store/tank-supply-list/TankSupplyParam'
import { isValidArray } from '@/utils/utilsMethods'
import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
const table = tableClass.getTable() // 引用表格参数类

const form = tableClass.getForm() // 引用表格参数类

import { tankFarmSupplyRules } from '../dataConfig/rules'

const requiredItems = () => {
  const keys = []
  for (const key in tankFarmSupplyRules) {
    if (tankFarmSupplyRules[key].some(item => item.required)) {
      keys.push(key)
    }
  }
  return keys
}

const validateData = (item) => {
  for (const key in item) {
    if (requiredItems().some(i => i === key)) {
      if (!item[key]) {
        return { state: false, key: key }
      } else if (typeof item[key] === 'string' && item[key] === '') {
        return { state: false, key: key }
      } else if (Object.prototype.toString.call(item[key]) === 'Array' && item[key].length == 0) {
        return { state: false, key: key }
      }
    }
  }
}

export default {
  name: 'TankSupplyList',
  components: {
    tankSupplyInfo,
    demandSuggest,
    warehouseCompany
  },
  data: function() {
    // 租金校验方法
    var expectPrice = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入租金'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 罐区容积校验方法
    var validateArea = (rule, value, callback) => {
      if (parseFloat(this.queryParams.potStartArea) > parseFloat(this.queryParams.potEndArea)) {
        callback(new Error('请输入最大值'))
      } else {
        callback()
      }
    }
    // 储罐规格校验方法
    var storageTankStandard = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入储罐规格'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 储罐直径校验方法
    var storageTankDiameter = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入储罐直径'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 储罐高度校验方法
    var storageTankHeight = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入储罐高度'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 罐区面积校验方法
    var potArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入罐区面积'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 起租罐数校验方法
    var leasePotCount = (rule, value, callback) => {
      const number = {
        reg: /^[1-9]{1}[0-9]*$/,
        title: '请输入正确内容(正数、包括小数)'
      }
      if (!value) {
        return callback(new Error('请输入起租罐数'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (!this.tankFarmSupply.tenantablePotCount) {
            return callback(new Error('请先输入可租罐数'))
          } else {
            if (parseFloat(this.tankFarmSupply.tenantablePotCount) < parseFloat(value)) {
              return callback(new Error('起租罐数超出范围(不得超出可租罐数)'))
            } else {
              callback()
            }
          }
        }
      }
    }
    // 可租罐数校验方法
    var tenantablePotCount = (rule, value, callback) => {
      const number = {
        reg: /^[1-9]{1}[0-9]*$/,
        title: '请输入正确内容(正数)'
      }
      if (!value) {
        return callback(new Error('请输入可租罐数'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          callback()
        }
      }
    }
    return {
      invitationManager: {
        visible: false,
        close: () => {
          this.invitationManager.visible = false
        }
      },
      recommendManager: {
        visible: false,
        close: () => {
          this.loadData()
          this.recommendManager.visible = false
        }
      },
      companyManager: {
        visible: false,
        type: 'invite',
        title: '邀请企业信息',
        data: null,
        close: () => {
          this.companyManager.visible = false
        }
      },
      data: [],
      area: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      allSelection: false,
      demandSuggestData: {},
      storageType: {
        storageType: [],
        fireQualification: [],
        fireResistanceRating: [],
        tankType: [],
        storageTankShape: [],
        storageTankType: [],
        leaseTerm: []
      },
      configParams: {
        startPlaceList: {},
        stopPlaceList: {},
        transportTypeList: {}
      },
      // 表格数据
      pagination: table.Page,
      // 推荐分页
      recommendPagination: table.Page,
      // 验证数据一致性
      rules: form.rules,
      // 罐区容积验证
      rule: {
        potEndArea: [
          { validator: validateArea, trigger: 'blur' }]
      },
      queryParams: {
        supplyName: null,
        storageType: null,
        leasePotCount: null,
        potStartArea: null,
        potEndArea: null,
        storageLocation: null
      },
      state: '1',
      viewManager: {
        loading: true
      },
      tankSupplyFile: 'cangchuFile',
      tankFarmSupply: {
        longLat: '',
        supplyName: null, // 租单名称
        storageTankShape: null, // 储罐形状
        storageType: [], // 储存类型
        cargoName: null, // 货物名称
        leaseTime: null, // 起租日期
        companyId: '2', // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageTankStandard: null, // 储罐规格
        storageTankHeight: null, // 储罐高度
        storageTankDiameter: null, // 储罐直径
        storageTankType: null, // 储罐型号
        leasePotCount: null, // 起租罐数
        tenantablePotCount: null, // 可租罐数
        expectPrice: null, // 租金
        leaseTerm: null, // 起租年限
        storageLocation: null, // 库房位置
        detailedLocation: null, // 详细位置
        potArea: null, // 罐区面积
        fireResistanceRating: null, // 罐区耐火级
        fireQualification: null, // 消防资质
        fireInformation: null, // 消防信息
        storageUrl: null, // 库房照片(最多可上传6张)
        remarks: null, // 备注
        publishStatus: null // 发布状态 1已发布 2未发布
      },
      tankFarmSupplyRules: {
        supplyName: [{ required: true, validator: this.$character(1, 50, 'check'), trigger: 'blur' }], // 租单名称
        storageTankShape: [{ required: true, message: '请选择储罐形状', trigger: 'change' }], // 储罐形状
        storageType: [{ type: 'array', required: true, message: '请至少选择一个储存类型', trigger: 'change' }], // 储存类型
        cargoName: [{ required: true, validator: this.$character(1, 20, 'check'), trigger: 'blur' }], // 货物名称
        leaseTime: [{ required: true, message: '请选择起租日期', trigger: 'change' }], // 起租日期
        companyName: [{ required: true, message: '未认证、请先认证个人信息', trigger: 'blur' }], // 公司名称
        linkMan: [{ required: true, validator: this.$character(2, 11, 'check'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        storageTankStandard: [{ required: true, validator: storageTankStandard }], // 储罐规格
        storageTankHeight: [{ required: true, validator: storageTankHeight }], // 储罐高度
        storageTankDiameter: [{ required: true, validator: storageTankDiameter }], // 储罐直径
        storageTankType: [{ required: true, message: '请选择储罐型号', trigger: 'change' }], // 储罐型号
        leasePotCount: [{ required: true, validator: leasePotCount }], // 起租罐数
        tenantablePotCount: [{ required: true, validator: tenantablePotCount }], // 可租罐数
        expectPrice: [{ required: true, validator: expectPrice }], // 租金
        leaseTerm: [{ required: true, message: '请选择起租年限', trigger: 'change' }], // 起租年限
        storageLocation: [{ required: true, message: '请选择库房位置', trigger: 'change' }], // 库房位置
        detailedLocation: [{ required: true, validator: this.$character(2, 20, 'check'), trigger: 'blur' }], // 详细位置
        potArea: [{ required: true, validator: potArea }], // 罐区面积
        fireResistanceRating: [{ required: true, message: '请选择罐区耐火等级', trigger: 'change' }], // 罐区耐火级
        fireQualification: [{ required: true, message: '请选择消防资质', trigger: 'change' }], // 消防资质
        fireInformation: [{ required: true, validator: this.$character(1, 300, 'check'), trigger: 'blur' }], // 消防信息
        // storageUrl: [{ required: true, message: '请输入库房照片', trigger: 'blur' }], // 库房照片(最多可上传6张)
        remarks: [{ required: true, validator: this.$character(2, 200, 'check'), trigger: 'blur' }] // 仓库简介
      }
    }
  },
  computed: {
    getPublishState() {
      return this.state
    }
  },
  watch: {
    state: function() {
      this.loadData()
    },
    'queryParams.potStartArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.queryParams.potEndArea)) {
          this.queryParams.potEndArea = ''
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.potStartArea = ''
        } else {
          if (parseFloat(this.queryParams.potStartArea) > parseFloat(this.queryParams.potEndArea)) {
            // this.queryParams.potEndArea = this.queryParams.potStartArea
          }
        }
      }
    },
    'queryParams.potEndArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.queryParams.potStartArea)) {
          this.queryParams.potStartArea = ''
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.potEndArea = ''
        }
      }
    },
    'queryParams.leasePotCount': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (val != null && val != '' && (val == 0 || !reg.test(val))) {
          this.queryParams.leasePotCount = 1
        }
      }
    },
    'queryParams.supplyName': {
      handler: function(val) {
        var reg = this.$character(1, 20, 'regular')
        if (!reg.test(this.queryParams.supplyName)) {
          this.queryParams.supplyName = ''
        }
      }
    }
  },
  created: function() {
    (async() => {
      await this.getArea()
      await this.getStorageType()
      await this.getFireQualification()
      await this.getFireResistanceRating()
      await this.getTankType()
      await this.getStorageTankShape()
      await this.getStorageTankType()
      await this.getLeaseTerm()
      this.loadData()
    })()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadData()
      }
    }
  },
  methods: {
    // 仓库面积范围
    startChange(val) {
      if (!this.isEmpty(this.queryParams.potEndArea) && this.isEmpty(this.queryParams.potStartArea)) {
        // this.queryParams.potStartArea = 1
      }
    },
    // 仓库面积范围
    endChange(val) {
      if (!this.isEmpty(this.queryParams.potStartArea) && this.isEmpty(this.queryParams.potEndArea)) {
        this.queryParams.potEndArea = ''
      }
      if (parseFloat(this.queryParams.potStartArea) > parseFloat(this.queryParams.potEndArea)) {
        // console.log(`监控数据`)
        // this.queryParams.potEndArea = this.queryParams.potStartArea
      }
    },
    // 判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
        console.log('执行了')
      }, 100)
    },
    // 详情位置回调
    handleSelect(item) {
      console.log(item)
      const con = item.location.lat + ',' + item.location.lng
      this.tankFarmSupply.longLat = con
    },
    // 地图定位查询
    querySearch(queryString, cb) {
      const addres = this.tankFarmSupply.storageLocation
      if (addres == null || addres == '') {
        var isError = document.getElementsByClassName('storageLocation')
        this.tankFarmSupply.detailedLocation = ''
        isError[0].querySelector('input').focus()
        cb([])
        this.$message({
          message: '请先选择库房位置!',
          offset: 100,
          type: 'warning'
        })
        // this.isErrorShow('请先选择库房位置!')
        return
      }
      if (queryString == null || queryString == '') {
        cb([])
        return
      }
      var results = []
      // const map = this.map
      AMap.service(['AMap.PlaceSearch'], () => {
      // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          // city: '邹平', // 兴趣点城市
          city: addres[addres.length - 1],
          citylimit: true // 是否强制限制在设置的城市内搜索
          // map: map // 展现结果的地图实例
        // panel: 'panel', // 结果列表将在此容器中进行展示。
        // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 关键字查询
        placeSearch.search(queryString, (status, result) => {
          // alert(JSON.stringify(b))
          console.log(JSON.stringify(status))
          if (status == 'complete') {
            result.poiList.pois.forEach(element => {
              results.push({ 'title': element.name, 'value': element.address + element.name, 'address': element.name, 'location': element.location })
            })
            cb(results)
          } else {
            this.tankFarmSupply.detailedLocation = ''
            cb(results)
            this.$message({
              message: '暂无数据!',
              offset: 100,
              type: 'warning'
            })
            // this.isErrorShow('暂无数据!')
            // cb(results)
          }
        })
      })
    },
    // 详情地址错误提示
    isErrorShow(errName) {
      setTimeout(function() {
        var isDetailsError = document.getElementsByClassName('detailedLocation')
        var detaError = isDetailsError[0].querySelector('.el-form-item__error')
        if (!detaError) {
          var autocomplete = isDetailsError[0].querySelector('.el-form-item__content')
          var btn = document.createElement('div')
          var att = document.createAttribute('class')
          att.value = 'el-form-item__error'
          btn.setAttributeNode(att)
          var t = document.createTextNode(errName)
          btn.appendChild(t)
          autocomplete.appendChild(btn)
          // var t=document.createTextNode("CLICK ME");
        } else {
          detaError.innerHTML = errName
        }
      }, 100)
    },
    // 详情展示
    supplyInfo(supply) {
      if (supply.hidden) {
        this.data.map(res => {
          res.hidden = true
          return res
        })
      }
      supply.hidden = !supply.hidden
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType').then((storageType) => {
        if (storageType.length > 0) {
          storageType.forEach(res => {
            this.storageType.storageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageType').then(res => {
          const storageType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageType', storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 消防资质字典
    getFireQualification() {
      this.getLocalStorageUtil('fireQualification').then((fireQualification) => {
        if (fireQualification.length > 0) {
          fireQualification.forEach(res => {
            this.storageType.fireQualification.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireQualification').then(res => {
          const fireQualification = JSON.parse(res.result)
          this.setLocalStorageUtil('fireQualification', fireQualification)
          if (fireQualification.length > 0) {
            fireQualification.forEach(res => {
              this.storageType.fireQualification.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区耐火等级字典
    getFireResistanceRating() {
      this.getLocalStorageUtil('fireResistanceRating').then((fireResistanceRating) => {
        if (fireResistanceRating.length > 0) {
          fireResistanceRating.forEach(res => {
            this.storageType.fireResistanceRating.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireResistanceRating').then(res => {
          const fireResistanceRating = JSON.parse(res.result)
          this.setLocalStorageUtil('fireResistanceRating', fireResistanceRating)
          if (fireResistanceRating.length > 0) {
            fireResistanceRating.forEach(res => {
              this.storageType.fireResistanceRating.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区储存类型字典
    getTankType() {
      this.getLocalStorageUtil('tankType').then((tankType) => {
        if (tankType.length > 0) {
          tankType.forEach(res => {
            this.storageType.tankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('tankType').then(res => {
          const tankType = JSON.parse(res.result)
          this.setLocalStorageUtil('tankType', tankType)
          if (tankType.length > 0) {
            tankType.forEach(res => {
              this.storageType.tankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 储罐形状类型字典
    getStorageTankShape() {
      this.getLocalStorageUtil('storageTankShape').then((storageTankShape) => {
        if (storageTankShape.length > 0) {
          storageTankShape.forEach(res => {
            this.storageType.storageTankShape.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageTankShape').then(res => {
          const storageTankShape = JSON.parse(res.result)
          this.setLocalStorageUtil('storageTankShape', storageTankShape)
          if (storageTankShape.length > 0) {
            storageTankShape.forEach(res => {
              this.storageType.storageTankShape.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 储罐型号类型字典
    getStorageTankType() {
      this.getLocalStorageUtil('storageTankType').then((storageTankType) => {
        if (storageTankType.length > 0) {
          storageTankType.forEach(res => {
            this.storageType.storageTankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageTankType').then(res => {
          const storageTankType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageTankType', storageTankType)
          if (storageTankType.length > 0) {
            storageTankType.forEach(res => {
              this.storageType.storageTankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 起租年限类型字典
    getLeaseTerm() {
      this.getLocalStorageUtil('leaseTerm').then((leaseTerm) => {
        if (leaseTerm.length > 0) {
          leaseTerm.forEach(res => {
            this.storageType.leaseTerm.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('leaseTerm').then(res => {
          const leaseTerm = JSON.parse(res.result)
          this.setLocalStorageUtil('leaseTerm', leaseTerm)
          if (leaseTerm.length > 0) {
            leaseTerm.forEach(res => {
              this.storageType.leaseTerm.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 邀请企业信息
    inviteClick(res) {
      this.companyManager.type = 'invite'
      this.companyManager.title = '邀请企业信息'
      this.companyManager.data = res
      this.companyManager.visible = true
    },
    // 邀请企业信息
    orderClick(res) {
      this.companyManager.type = 'order'
      this.companyManager.title = '预约企业信息'
      this.companyManager.data = res
      this.companyManager.visible = true
    },
    // 列表切换监听
    toggleState(state) {
      this.state = state
      this.loadData()
    },
    // 需求推荐
    popRecommendList(id) {
      console.log(id)
      this.demandSuggestData = id
      // 根据id查询出对应列表
      this.recommendManager.visible = true
    },
    // 重置
    resetForm() {
      this.$refs['form'].resetFields()
      this.queryParams.storageLocation = null
      this.loadData()
    },
    // 子项选择
    change() {
      this.allSelection = this.data.every(i => i.selection)
    },
    // 全选
    selection() {
      this.data.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 分页监听
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 分页监听
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 批量删除
    batchDel() {
      const ids = this.data.filter(item => item.selection).map(item => item.id)
      if (ids.length > 0) {
        this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delBatch({ id: ids.join(',') })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: '删除成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: '请选择要删除的数据!'
        })
      }
    },
    // 初始化查询
    loadData() {
      if (parseFloat(this.queryParams.potStartArea) > parseFloat(this.queryParams.potEndArea)) {
        return
      }
      this.viewManager.loading = true
      this.queryParams.publishStatus = this.getPublishState
      // this.queryParams.userId = null
      this.queryParams.myType = true
      this.loadTableData()
      this.allSelection = false
    },
    // 查询列表
    loadTableData() {
      const params = Object.assign(this.pagination, this.queryParams)
      if (params.storageLocation != null && params.storageLocation.length > 0) {
        params.storageLocation = params.storageLocation.join('#')
      }
      findPageSupply(params)
        .then(data => {
          console.log(data)
          this.data = data.result.rows.map(res => {
            res.hidden = true
            res.selection = false
            return res
          })
          this.pagination.total = data.result.total
        })
        .catch(error => {
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    // 删除
    del(id) {
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (id) {
            supplyRemove({ id: id })
              .then(data => {
                this.$message({
                  offset: 100,
                  type: 'success',
                  message: '删除成功!'
                })
                this.loadData()
              })
              .cacth(error => {
                console.error(error)
              })
          }
        })
    },
    // 发布或编辑货源
    edit(supply) {
      const supplyData = JSON.parse(JSON.stringify(supply))
      if (supplyData) {
        if (supplyData.storageType) {
          supplyData.storageType = supplyData.storageType.split(',')
        } else {
          supplyData.storageType = []
        }
        if (supplyData.storageLocation) {
          supplyData.storageLocation = supplyData.storageLocation.split('#')
        } else {
          supplyData.storageLocation = []
        }
      }
      this.tankFarmSupply = supplyData
      this.invitationManager.visible = true
    },
    tankFarmSupplyEdit(rulesForm) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            // console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const supply = JSON.parse(JSON.stringify(this.tankFarmSupply))
          if (this.tankFarmSupply) {
            if (isValidArray(this.tankFarmSupply.storageLocation)) {
              supply.storageLocation = this.tankFarmSupply.storageLocation.join('#')
            } else {
              supply.storageLocation = ''
            }
            if (this.tankFarmSupply.storageType) {
              supply.storageType = this.tankFarmSupply.storageType.toString()
            } else {
              supply.storageType = ''
            }

            if (this.tankFarmSupply.storageUrl) {
              supply.storageUrl = this.tankFarmSupply.storageUrl.toString()
            } else {
              supply.storageUrl = ''
            }
          }
          supply.createBy = null
          supply.updateBy = null
          supply.inviteUser = null
          supply.orderUser = null
          supplyEdit(supply).then((result) => {
            // 成功提示
            this.$message({
              offset: 100,
              showClose: true,
              message: '恭喜你，数据修改成功',
              type: 'success'
            })
          }).catch((err) => {
            console.log(err)
          }).finally(() => {
            this.post_flag = false
            this.invitationManager.visible = false
            this.loadData()
          })
        } else {
          // 失败返回数据
          return false
        }
      })
    },
    // 单条发布
    publishGetSupply(status, res) {
      // const ids = this.data.filter(item => item.selection).map(item => item.id)
      if (res != null && res.id != null) {
        this.$confirm(`是否确定${status == '2' ? '发布' : '下架'}本条罐区供给信息`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (status == '2') {
            const result = validateData(res)
            if (result && !result.state) {
              this.$message({
                type: 'error',
                message: `数据不完整，请先填写完整再发布!`
              })
              return false
            }
          }
          issueBatch({ id: JSON.stringify([res.id]), publishStatus: status })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: status == '2' ? '发布成功!' : '下架成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: status == '2' ? '请选择要发布的数据!' : '请选择要下架的数据!'
        })
      }
    },
    // 批量发布
    publishsupply(status) {
      const items = this.data.filter(item => item.selection)
      if (items.length > 0) {
        this.$confirm(`是否确定${status == '2' ? '发布' : '下架'}选中的罐区供给信息`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = null
          if (status == '2') {
            ids = items.filter((item, index) => {
              const result = validateData(item)
              if (result && !result.state) {
                this.$message({
                  offset: 100,
                  type: 'error',
                  message: `所选第${parseInt(index) + 1}条数据不完整，请先填写完整再发布!`
                })
                return false
              }
              return true
            }).map(i => i.id)
          } else {
            ids = items.map(i => i.id)
          }
          if (ids === null || ids.length === 0) {
            return false
          }
          issueBatch({ id: JSON.stringify(ids), publishStatus: status })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: status == '2' ? '发布成功!' : '下架成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: status == '2' ? '请选择要发布的数据!' : '请选择要下架的数据!'
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

/deep/a{
  text-decoration: none;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
$main-color: #be2316;

/deep/.el-select{
  width:100%;
}

/deep/.el-input-group__append, .el-input-group__prepend {
      background-color: #ffffff;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #DCDFE6;
      border-left: 0;
      border-radius: 0px;
      padding: 0 10px;
      width: 1px;
      white-space: nowrap;
  }

.content-container {
  .supply-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .supply-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }
        .supply-condition{
          display: flex;
          flex-wrap: wrap;
          /deep/.el-form-item .el-form-item__content{
            display: flex;
            flex-wrap: wrap;
            width: 217px;
            .supply-area{
              display: inline-flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              padding: 3px 10px;
              -webkit-appearance: none;
              background-color: #FFF;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #DCDFE6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              width: 100%;
              /deep/.el-form-item__content{
                width: auto;
              }
              &:focus {
                  border-color: #409EFF;
                  outline: 0;
              }
              &:hover {
                  border-color: #C0C4CC;
              }
              .el-form-item{
                padding-right: 0px;
                width: 100%;
                margin-right: 0 !important;
                /deep/.el-input .el-input__inner {
                    border: 0px solid #DCDFE6;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                }
              }
            }
          }
          .el-form-item{
              display: flex;
              -webkit-box-pack: end;
              -ms-flex-pack: end;
              justify-content: flex-end;
              padding-right: 22px;
              width: 50%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              margin-right: 0 !important;
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;
  }

  .supply-data {
    .supply-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 15.8%;
          }
          &:nth-child(3) {
            flex-basis: 15.8%;
          }
          &:nth-child(4) {
            flex-basis: 15.8%;
          }
          &:nth-child(5) {
            flex-basis: 15.8%;
          }
          &:nth-child(6) {
            flex-basis: 15.8%;
          }
          &:nth-child(7) {
            flex-basis: 15.8%;
          }
        }
      }
    }

    .supply-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
           &:nth-child(1) {
              flex-basis: 5%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(3) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(4) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(5) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(6) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(7) {
              flex-basis: 15.8%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button{
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .supply-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }

  .tankSupply-data {
    .supply-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 12%;
          }
          &:nth-child(2) {
            flex-basis: 12%;
          }
          &:nth-child(3) {
            flex-basis: 12%;
          }
          &:nth-child(4) {
            flex-basis: 12%;
          }
          &:nth-child(5) {
            flex-basis: 12%;
          }
          &:nth-child(6) {
            flex-basis: 12%;
          }
          &:nth-child(7) {
            flex-basis: 12%;
          }
          &:nth-child(8) {
            flex-basis: 16%;
          }
        }
      }
    }

    .supply-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(2) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(3) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(4) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(5) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(6) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(7) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 2px 0.4% ;
            }
            &:nth-child(8) {
              flex-basis: 16%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button{
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .supply-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }

  .orderSupply-data {
    .supply-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16.8%;
          }
          &:nth-child(2) {
            flex-basis: 16.8%;
          }
          &:nth-child(3) {
            flex-basis: 16.8%;
          }
          &:nth-child(4) {
            flex-basis: 16.8%;
          }
          &:nth-child(5) {
            flex-basis: 16.8%;
          }
          &:nth-child(6) {
            flex-basis: 16%;
          }
        }
      }
    }

    .supply-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(2) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(3) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(4) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(5) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(6) {
              flex-basis: 16%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button{
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .supply-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }

  // .invitation-data {
  //   .invitation-data-header {
  //     color: $main-color;
  //     font-weight: bold;
  //     background-color: #ffffff;
  //     height: 45px;
  //     margin-bottom: 1rem;
  //     ul {
  //       display: flex;
  //       flex-wrap: nowrap;
  //       height: 100%;
  //       width: calc(100% - 16px);
  //       padding: 8px 8px;
  //       box-sizing: content-box;
  //       li {
  //         overflow: hidden;
  //         white-space: nowrap;
  //         text-overflow: ellipsis;
  //         font-size: 15px;
  //         min-width: 50px;
  //         height: 100%;
  //         line-height: 29px;
  //         text-align: center;
  //         &:nth-child(1) {
  //           flex-basis: 15%;
  //         }
  //         &:nth-child(2) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(3) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(4) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(5) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(6) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(7) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(8) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(9) {
  //           flex-basis: 15%;
  //         }
  //         &:nth-child(10) {
  //           flex-basis: 15%;
  //         }
  //       }
  //     }
  //   }
  //   .invitation-data-body {
  //     position: relative;
  //     .data-item {
  //       margin: 8px 0px;
  //       box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  //       border: 1px solid #ebeef5;
  //       position: relative;
  //       ul {
  //         display: flex;
  //         flex-wrap: nowrap;
  //         height: 56px;
  //         width: calc(100% - 16px);
  //         padding: 8px 8px;
  //         position: relative;
  //         background-color: white;
  //         li {
  //           overflow: hidden;
  //           white-space: nowrap;
  //           text-overflow: ellipsis;
  //           font-size: 15px;
  //           min-width: 50px;
  //           height: 100%;
  //           line-height: 64px;
  //           text-align: center;
  //           &:nth-child(1) {
  //             flex-basis: 15%;
  //           }
  //           &:nth-child(2) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(3) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(4) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(5) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(6) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(7) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(8) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(9) {
  //             flex-basis: 15%;
  //           }
  //           &:nth-child(10) {
  //             flex-basis: 15%;
  //           }
  //         }
  //       }
  //       /deep/ .supply-item-details {
  //         border: 1px solid #ebeef5;
  //         z-index: 0;
  //       }
  //     }
  //   }
  //   .invitation-data-pagination {
  //     width: calc(100% - 32px);
  //     margin-top: 24px;
  //     padding: 16px 0px;
  //     background-color: white;
  //   }
  // }

  .bid-data {
    .bid-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 8%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 7%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
          &:nth-child(11) {
            flex-basis: 10%;
          }
        }
      }
    }
    .bid-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
            }
            &:nth-child(3) {
              flex-basis: 8%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 7%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
            &:nth-child(11) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .bid-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-data {
    .recommend-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
        }
      }
    }
    .recommend-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .recommend-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
}
</style>
